import apiClient from './../apiClient'
import authApi from './auth'
import importsApi from './imports'
import propertiesApi from './properties'

export default function api() {
  const dataV2 = { apiClient: apiClient({ prefix: 'api/v2' }) }

  return {
    properties: propertiesApi(dataV2),
    auth: authApi(dataV2),
    imports: importsApi(dataV2),
  }
}
